import { useState, lazy, Suspense, Fragment, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useGetOrderQuery, formatter, statusTable } from "context/order/orderApiSlice";
import  useAlert  from "hooks/useAlert";
import { formatDistanceToNow, parseISO, format } from 'date-fns';
import frLocale from 'date-fns/locale/fr';

import { Grid, Card, Icon, Container, Divider, Tooltip, Badge, styled } from "@mui/material";

import CssBaseline from '@mui/material/CssBaseline';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDBadge from "dashboard/components/MDBadge";
import Footer from "dashboard/examples/Footer";
import MDAvatar from "dashboard/components/MDAvatar";
import MDButton from "dashboard/components/MDButton";

import DashboardLayout from "dashboard/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "dashboard/examples/Navbars/DashboardNavbar";
import OrderTimeLine from "components/sections/orders/sections/orderTimeLine";
import loader from "assets/images/shapes/loader.svg";


const Map = lazy(() =>import("components/sections/orders/components/Googlemap"));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  [`& .MuiTableCell-root`]: {
    fontSize: 12,
    padding : 5,
    color : theme.palette.text.main
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },

}));

export default function OrderDetails()  {
  const [showMap, setShowMap] = useState(false);
  const {showAlerts} = useAlert();
  const {id, activity} = useParams();

  const { order } = useGetOrderQuery(undefined, {
    selectFromResult: ({ data }) => ({
        order : data?.entities[id]
    }),
  })
  const formatDateString = date => date ? format(parseISO(date), "dd MMM yyyy\t",{locale: frLocale}) : "En cours";

  const downloadFile = (url) => {
    const anchor = document.createElement('a');
    anchor.href =  `https://granitex.dz/granitex-software/invoices/${url}`;
    anchor.target ="_black";
    anchor.download = url;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };
  
  // eslint-disable-next-line
  const printPdf = e =>{
    const urlpdf = e.target.getAttribute('pdfsrc');
    if(!urlpdf || urlpdf === ""){
      return showAlerts({code:"error", icon:"warning", title : "imprimer la facture !", msg : "La facture n'est pas encore générée ?  ", type : "toast"});
    }
    downloadFile(urlpdf);
  }

  if(!order) return <MDBox/>
  
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <CssBaseline />
      <Container sx={{maxWidth : {lg : '1024px !important'}}} disableGutters={false} maxWidth={false}> 
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  mb={2}
                  p={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  sx={{display: "flex", justifyContent:"space-between"}}
                >
                  <MDTypography  variant="h4" color="white">
                      Détails de la commande
                  </MDTypography>
                  <MDButton onClick={()=>setShowMap(!showMap)} size="small" sx={{ marginRight:2}}  startIcon={<Icon fontSize="2xl" >location_on</Icon>} >{showMap ? "masquer la carte " : "Montrer sur la carte"}</MDButton>     
                  </MDBox>
                  <Suspense fallback={<MDAvatar display="flex" sx={{padding: 0,position: "absolute",zIndex: 9,
                    top: "50%",left: "50%",transform: "translate3d(-24px, -40px, 0)"}}  
                    src={loader} alt="Avatar" variant="square" size="md" />}>
                      {showMap && <MDBox p={{ lg:2 }}>
                        <Map userMarker={`${process.env.REACT_APP_PUBLIC_URL}/img/profil/${order.userid?.photoURL}`} clientPosition={order.shippingAddress.location.coordinates} />
                      </MDBox>}
                  </Suspense>
                  <MDBox p={{ lg:2 }}>
                    <Grid container >
                      <Grid sx={{justifyContent:"space-between", display:"flex", my:1}} xs={12} item>
                        <MDBox sx={{ display:"inline-block"}}>
                        <MDTypography variant="body2" color="text" sx={{fontSize : 14}}>Date : <b> {order.number}</b> depuis <b>{format(parseISO(order.createdAt), "dd MMM yyyy\t",{locale: frLocale})}</b></MDTypography>
                        <MDTypography variant="body2" color="text" sx={{fontSize : 14}}>Code : <b> {order.code}</b> </MDTypography>
                        </MDBox>
                        <MDBox sx={{ display:"inline-block"}}>
                          <MDButton  pdfsrc={order.invoiceUrl} onClick={(e)=>printPdf(e)} color="dark" variant='gradient' size="small" sx={{ mx:2, "& .material-icons-round":{fontSize :"1rem !important"}}} >
                            <Icon fontSize="large" sx={{mx:1}}>print</Icon> 
                            Facture
                          </MDButton>
                        </MDBox>
                      </Grid>
                      <Divider sx={{width:"100%"}}/>
                      <Grid xs={12} sx={{justifyContent:"space-between", alignItems:"center", display:"flex", my:1}} container item>
                        <Grid xs={12} sx={{justifyContent:"left", alignItems:"felx-start", display:"flex"}} md={6} item>
                          <MDAvatar sx={{display:"inline-block", mr :1.5}} src={`${process.env.REACT_APP_PUBLIC_URL}/img/${order.userid?.photoURL}`} alt="Avatar" variant="rounded" shadow="md"  size="xxl" />
                          <MDBox sx={{ display:"inline-block", alignSelf :"start"}}>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 14}}><b>Customer : </b> {order.userid?.displayName} </MDTypography>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 14}}>
                              Commande {order.color === "light" ? "Reçu" : order.step.status} il y a {formatDistanceToNow(parseISO(order.step.stepDate), { locale: frLocale })} 
                            </MDTypography>
                            <MDBadge sx={{backGroundColor: ({functions:{rgba}, palette })=>rgba(palette[order.step.color].main, 0.3), "& .MuiBadge-badge" : {border:({palette})=>`1px solid ${palette[order.step.color].main}`}}} circular badgeContent={order.step.status}  variant="contained" size="sm" color={order.step.color} border />
                          </MDBox>
                        </Grid>
                        <Grid xs={12} md={6} sx={{textAlign: "right"}} item>
                          <MDButton component={Link} color="dark" variant='gradient' to="/#Contact" size="small" sx={{ marginRight:2, mb:1}} >Contacter Nous</MDButton> 
                          <MDTypography variant="body2" sx={{fontSize : 14}} color="secondary">Aimez-vous le produit? Laissez-nous un avis ici.</MDTypography>
                        </Grid>
                      </Grid>
                      <Divider sx={{width:"100%"}} />
                      <Grid xs={12} md={3} item><OrderTimeLine formatDateString={formatDateString} statusTable={statusTable} orderDelivery={order}/></Grid>
                      <Grid xs={12} md={5} item>
                      <TableContainer component={Paper} sx={{boxShadow:"none", px:2, py : {sm : 1.5, lg:3}}}>
                        <MDTypography variant="h6">Liste de produits</MDTypography>
                        <Table sx={{ minWidth: "100%" }} size="small" aria-label="caption table">
                            <TableBody>
                              <TableRow>
                                <TableCell align="center"  sx={{color:'text.main'}} colSpan={2}>produit</TableCell>
                                <TableCell align="center" sx={{color:'text.main'}}>Quantité</TableCell>
                              </TableRow> 
                              {order.orderItems?.map( product => (
                                <Fragment key={product.id}>
                                  <StyledTableRow>
                                    <TableCell size="small" scope="row">
                                    <Badge badgeContent={product.quantity} sx={{'& .MuiBadge-anchorOriginTopRightRectangular':{fontSize:10, top:5, right : 5}}} color="error">
                                      <MDAvatar variant="rounded" imgType="product" src={`${process.env.REACT_APP_PUBLIC_URL}/img/${product.selectedImage}`} alt={product.productName} size="md"  />
                                    </Badge>
                                    </TableCell>
                                    <TableCell  size="small" align="center">
                                      <Tooltip title="Check this product" placement="top" arrow>
                                        <MDButton sx={{px:1.5, py : 1}} target="_blank" component={Link} to={`/product/${product.id}`}>{product.productName}</MDButton>
                                      </Tooltip>
                                    </TableCell>
                                    <TableCell align="center"><MDTypography variant="body2" color="primary">{formatter('DZD').format(product.price)}</MDTypography></TableCell>
                                  </StyledTableRow>
                                  <StyledTableRow sx={{backgroundColor:"transparent !important"}}>
                                      <TableCell  size="small" align="center" ><Icon>expand</Icon></TableCell>
                                      <TableCell  size="small" align="center" ><Icon>straighten</Icon></TableCell>
                                      <TableCell  size="small" align="center" ><Icon>palette</Icon></TableCell>
                                  </StyledTableRow>
                                  <StyledTableRow >
                                    <TableCell variant="head"  size="small" align="center">{product.details?.sizes?.join(', ')}</TableCell>
                                    <TableCell variant="body" size="small" align="center">
                                        <MDBox display="flex"><MDBox size="small" width={37} >length</MDBox><MDBox textAlign="center" display="flex" sx={{flexGrow:1}}  align="center" size="small" >{product.details?.dimensions?.length}</MDBox></MDBox>
                                        <MDBox display="flex"><MDBox size="small" width={37} >width</MDBox><MDBox align="center" size="small" >{product.details?.dimensions?.width}</MDBox></MDBox>
                                        <MDBox display="flex"><MDBox size="small" width={37} >height</MDBox><MDBox align="center" size="small" >{product.details?.dimensions?.height}</MDBox></MDBox>
                                    </TableCell>
                                    <TableCell variant="head" size="small" align="center">{product.colors?.join(', ')}</TableCell>
                                  </StyledTableRow>
                                </Fragment>
                              ))}
                            </TableBody>
                          </Table>
                      </TableContainer>
                      </Grid>
                      <Grid xs={12} md={4} item>
                        <MDBox pt={3} px={3}>
                          <MDTypography variant="h6">Récapitulatif</MDTypography>
                          <MDBox sx={{justifyContent:"space-between", display:"flex", my:1, mx : {lg:3}}}>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 14}}>Sous-Total : </MDTypography>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 14}}><b>{order.itemsPrice}</b></MDTypography>
                          </MDBox>
                          <MDBox sx={{justifyContent:"space-between", display:"flex", my:1, mx : {lg:3}}}>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 14}}>Livraisan : </MDTypography>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 14}}><b>{order.shippingPrice}</b></MDTypography>
                          </MDBox>
                          <MDBox sx={{justifyContent:"space-between", display:"flex", my:1, mx : {lg:3}}}>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 14}}>Taxes : </MDTypography>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 14}}><b>{order.taxesPrice}</b></MDTypography>
                          </MDBox>
                          <MDBox sx={{justifyContent:"space-between", display:"flex", my:1, mx : {lg:3}}}>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 14}}>Timbre fiscale : </MDTypography>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 14}}><b>{order.stampPrice}</b></MDTypography>
                          </MDBox>
                          <MDBox sx={{justifyContent:"space-between", display:"flex", my:1, mx : {lg:3}}}>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 18}}>Total : </MDTypography>
                            <MDTypography variant="body2" color="text" sx={{fontSize : 18}}><b>{order.totalPrice}</b></MDTypography>
                          </MDBox>
                          <Divider/>
                          <MDBox sx={{justifyContent:"space-between", display:"flex", my:1, mx : {lg:3}}}>
                          <MDTypography variant="body2" color="text" sx={{fontSize : 14}}>Mode de paiement : </MDTypography>
                          <MDTypography variant="body2" color="primary" sx={{fontSize : 14}} fontWeight="medium">
                            {order.paymentMethod}
                          </MDTypography>
                          </MDBox>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        </Container>
      <Footer />
    </DashboardLayout>
  );
}

